import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import i18n from "./i18n";
import firebase from "firebase/app";
import "firebase/firestore";
import { firestorePlugin } from "vuefire";
import "firebase/storage";
import "firebase/analytics";

import MaterialKit from "./plugins/material-kit";

require("firebase/auth");
Vue.use(firestorePlugin);

firebase.initializeApp({
  apiKey: "AIzaSyDevSvPpzZx0oLXiefATN4sdSHZAShD6zI",
  authDomain: "revelation-travel-4556e.firebaseapp.com",
  databaseURL: "https://revelation-travel-4556e-default-rtdb.firebaseio.com",
  projectId: "revelation-travel-4556e",
  storageBucket: "revelation-travel-4556e.appspot.com",
  messagingSenderId: "1064640637817",
  appId: "1:1064640637817:web:b9faf161a8524e2b761da8",
  measurementId: "G-SGSEKH6LXJ"
});

export const db = firebase.firestore();
Vue.config.productionTip = false;
router.beforeEach((to, from, next) => {
  let locale = navigator.language;
  let language = to.params.lang;
  if (!language) {
    language = locale;
  }
  i18n.locale = language;
  next();
});

Vue.use(MaterialKit);

const NavbarStore = {
  showNavbar: false
};

Vue.mixin({
  data() {
    return {
      NavbarStore
    };
  }
});

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount("#app");
